var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgToilet = function SvgToilet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 101 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.757 11.536H3.27v50.208a.86.86 0 0 0 .858.858H33.627l.13-51.066Z",
    fill: "#647F7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.215 11.536h34.623a.676.676 0 0 0 .598-.364.625.625 0 0 0 .13-.365v-9.63a.65.65 0 0 0-.234-.52L36.098.5H.93L.694.656a.729.729 0 0 0-.208.52v9.631a.86.86 0 0 0 0 .364.729.729 0 0 0 .625.365M13.492 20.073h-.39a3.173 3.173 0 0 0-2.68 1.458 3.437 3.437 0 0 0-.52 1.822c.028.412.124.817.287 1.197.16.362.39.689.676.963a3.019 3.019 0 0 0 2.159.937.99.99 0 0 0 .39 0h.859l.364-.182h.208l.494-.39c.153-.153.292-.319.416-.495.231-.356.39-.754.469-1.171a2.6 2.6 0 0 0 0-.625v-.494h9.026V20.49H13.622",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.886 57.267H13.779v61.062a1.173 1.173 0 0 0 1.17 1.171h42.74a1.2 1.2 0 0 0 1.197-1.171V57.267Z",
    fill: "#647F7F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.296 62.629a39.479 39.479 0 0 1-11.181 28.554A39.435 39.435 0 0 1 58.873 103.1a39.419 39.419 0 0 1-28.24-11.918A39.461 39.461 0 0 1 19.45 62.629v-5.362h78.845v5.362Z",
    fill: "#647F7F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.508 59.714h85.609a.729.729 0 0 0 .728-.729V54.9a.731.731 0 0 0-.728-.73h-85.61a.728.728 0 0 0-.728.73v4.086a.729.729 0 0 0 .729.729Z",
    fill: "#fff"
  })));
};

export default SvgToilet;